<template>
  <div class="like favoriteIcon" :class="{ 'notFavorite': !liked }" @click.prevent="like"></div>
</template>

<script>
export default {
  props: {
    id: Number,
    liked: Number,
    likeCount: Number,
    contentType: Number,
    likeStyle: {
      type: String,
      default: ''
    },
    auth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLikeCount() {
      return this.$store.getters['like/getLikeCount'];
    },
    getLiked() {
      return this.$store.getters['like/getLiked'];
    },
    getLikeStyle() {
      const liked = (this._liked == 1) ? ' liked' : '';
      return this.likeStyle + liked;
    }
  },
  data: () => ({
    _liked: 0,
    _like_count: 0,
    changing: false
  }),
  mounted() {
    this._liked = this.liked;
    this._like_count = this.likeCount;
  },
  watch: {
    getLiked(likedList) {
      if (likedList[this.contentType] != undefined &&
        likedList[this.contentType][this.id] != undefined &&
        this._liked != likedList[this.contentType][this.id]
      ) {
        this._liked = likedList[this.contentType][this.id];
      }
    }
  },
  methods: {
    like() {
      if (!this.auth) {
        // 未ログインモーダル
        this.$store.dispatch('like/setSignupAppeal', true);
        return;
      }
      if (!this.changing) {
        this.changing = true;
        let url;
        if (this._liked == 0) {
          url = '/api/users/like/add'; // お気に入り
          this._liked = 1;
          this._like_count += 1;
        } else {
          url = '/api/users/like/delete'; // お気に入り解除
          this._liked = 0;
          this._like_count -= 1;
        }
        this.$axios.post(url, {
          content_id: this.id,
          content_type: this.contentType
        })
        .then(() => {
          // お気に入り数を他コンポーネントに伝達
          const likeCounts = this.$_.cloneDeep(this.getLikeCount);
          likeCounts[this.contentType][this.id] = this._like_count;

          this.$store.dispatch('like/setLikeCount', likeCounts);

          // お気に入りしたか否かを他コンポーネントに伝達
          const liked = this.$_.cloneDeep(this.getLiked);
          liked[this.contentType][this.id] = this._liked;

          this.$store.dispatch('like/setLiked', liked);
        })
        .catch( (error) => {
          if (this._liked == 0) {
            this._liked = 1;
            this._like_count -= 1;
          } else {
            this._liked = 0;
            this._like_count += 1;
          }
        })
        .finally(() => {
          this.changing = false;
        });
      }
    }
  }
}
</script>

<style lang="scss">
  .like{
    cursor: pointer;
    z-index: 3;
    &.liked {
      background: url(/assets/img/common/heart.svg) center center/contain no-repeat !important;
    }
  }
</style>
